import "./flashdeals.css";
import React from "react";
import { list } from "../data/Servicedata";

const Flashdeals = () => {
  return (
    <div className="flashdeals mb">
      <div className="slider">
        <div className="mt b5 dark">
          <h1>Our Services</h1>
        </div>
        <div className="slide-track">
          {list.map((val, index) => {
            const { cover, name, description } = val;
            return (
              <div className="slide shadow2 " key={index}>
                <img src={cover} alt="" />
                <div className="onimg">
                  <h4>{name}</h4>
                  <p>{description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Flashdeals;
